module.exports = __webpack_public_path__ + "assets/widgets-091af5f08aa3033944885c0e3b2bb252.svg";